import React, { Fragment, useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import Modal from '../../../../../components/Modal';
import { formRequiredRules } from '../../../../../lib/formRules';
import Input from '../../../../../components/input/Input/Input';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import SelectForm from '../../../../../components/form/SelectForm';
import {
  MAXIMUM_NUMBER_OF_MEMO_TEXT,
  ORDER_CANCEL_ITEM_STATUS_TEXT,
  ORDER_EXCHANGE_STATUS_TEXT,
  ORDER_ITEM_DELAY_STATUS_CHANGE_LIST,
  ORDER_ITEM_STATUS,
  ORDER_ITEM_STATUS_CHANGE_INFO,
  ORDER_ITEM_STATUS_CHANGE_LIST,
  ORDER_ITEM_STATUS_TEXT,
  ORDER_RETURN_STATUS_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './OrderItemStatusChangeModal.scss';

const initList = [{ id: null, name: '선택' }];

const getReturnAndExchangeType = (acceptManager, receiveDate) => {
  if (acceptManager === 0) return 'MANAGER';
  if (receiveDate) return 'NORMAL';
  return 'PICK_UP_DELAY';
};

const OrderItemStatusChangeModal = (props) => {
  const { form, data, isOpen, closeModal, onSubmit, setData, changedStatus, memo } = props;
  const { isDelay, orderItemStatus, cancelHistory, exchangeHistory, returnHistory } = data;
  const [currentStatusText, setCurrentStatusText] = useState(ORDER_ITEM_STATUS_TEXT[orderItemStatus]);
  const [changeList, setChangeList] = useState(initList);
  const [changeInfo, setChangeInfo] = useState(ORDER_ITEM_STATUS_CHANGE_INFO.DEFAULT);

  useEffect(() => {
    switch (orderItemStatus) {
      case ORDER_ITEM_STATUS.DELIVERY_PREPARATION:
        setCurrentStatusText(ORDER_ITEM_STATUS_TEXT[orderItemStatus]);
        setChangeList(ORDER_ITEM_STATUS_CHANGE_LIST[orderItemStatus]);
        setChangeInfo(ORDER_ITEM_STATUS_CHANGE_INFO.DEFAULT);

        break;
      case ORDER_ITEM_STATUS.SHIPPING: {
        setCurrentStatusText(ORDER_ITEM_STATUS_TEXT[orderItemStatus]);
        const list = isDelay ? ORDER_ITEM_DELAY_STATUS_CHANGE_LIST : ORDER_ITEM_STATUS_CHANGE_LIST[orderItemStatus];
        setChangeList(list);
        setChangeInfo(ORDER_ITEM_STATUS_CHANGE_INFO.DEFAULT);

        break;
      }
      case ORDER_ITEM_STATUS.DELIVERY_COMPLETE: {
        setCurrentStatusText(ORDER_ITEM_STATUS_TEXT[orderItemStatus]);
        const list = isDelay ? ORDER_ITEM_DELAY_STATUS_CHANGE_LIST : ORDER_ITEM_STATUS_CHANGE_LIST[orderItemStatus];
        setChangeList(list);
        setChangeInfo(ORDER_ITEM_STATUS_CHANGE_INFO.DEFAULT);

        break;
      }
      case ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION: {
        setCurrentStatusText(ORDER_ITEM_STATUS_TEXT[orderItemStatus]);
        setChangeList(ORDER_ITEM_STATUS_CHANGE_LIST[orderItemStatus]);
        setChangeInfo(ORDER_ITEM_STATUS_CHANGE_INFO[orderItemStatus]);

        break;
      }
      case ORDER_ITEM_STATUS.CANCELLATION:
        setCurrentStatusText(ORDER_CANCEL_ITEM_STATUS_TEXT[cancelHistory.orderCancelStatus]);
        setChangeList(ORDER_ITEM_STATUS_CHANGE_LIST[orderItemStatus]);
        setChangeInfo(ORDER_ITEM_STATUS_CHANGE_INFO[orderItemStatus]);

        break;
      case ORDER_ITEM_STATUS.RETURN: {
        setCurrentStatusText(ORDER_RETURN_STATUS_TEXT[returnHistory.orderReturnStatus]);
        const { acceptManager, returnReceiveDate } = returnHistory;
        const changeList = ORDER_ITEM_STATUS_CHANGE_LIST[orderItemStatus];
        const changeInfo = ORDER_ITEM_STATUS_CHANGE_INFO[orderItemStatus];
        const status = getReturnAndExchangeType(acceptManager, returnReceiveDate);
        setChangeList(changeList[status]);
        setChangeInfo(changeInfo[status]);

        break;
      }
      case ORDER_ITEM_STATUS.EXCHANGE: {
        setCurrentStatusText(ORDER_EXCHANGE_STATUS_TEXT[exchangeHistory.orderExchangeStatus]);
        const { acceptManager, exchangeReceiveDate } = exchangeHistory;
        const changeList = ORDER_ITEM_STATUS_CHANGE_LIST[orderItemStatus];
        const changeInfo = ORDER_ITEM_STATUS_CHANGE_INFO[orderItemStatus];
        const status = getReturnAndExchangeType(acceptManager, exchangeReceiveDate);
        setChangeList(changeList[status]);
        setChangeInfo(changeInfo[status]);

        break;
      }
    }
  }, [isDelay, orderItemStatus, cancelHistory, exchangeHistory, returnHistory]);

  return (
    <Modal
      title="주문 상태 되돌리기"
      isOpen={isOpen}
      width={500}
      height={350}
      isFooter={true}
      okText="변경하기"
      onOk={() => onSubmit(orderItemStatus)}
      onClose={() => closeModal()}
    >
      <div className="order-item-status-change-modal">
        <div className="order-item-status-change">
          <div className="order-item-status">
            <div>현재</div>
            <Input value={currentStatusText} disabled={true} />
          </div>

          <FaArrowRight className="icon" size="50" />

          <div className="order-item-status">
            <div>변경</div>
            <SelectForm
              name="status"
              form={form}
              rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
              list={[...initList, ...changeList]}
              initialValue={changedStatus}
              onChange={(value) =>
                setData({
                  name: 'changedStatus',
                  value,
                })
              }
            />
          </div>
        </div>

        <div className="order-item-status-change-memo">
          <TextAreaForm
            form={form}
            rules={[formRequiredRules(true, REQUIRED_MSG)]}
            initialValue={memo}
            placeholder="변경 상세 사유를 입력해주세요."
            maxLength={MAXIMUM_NUMBER_OF_MEMO_TEXT}
            onChange={(value) =>
              setData({
                name: 'memo',
                value,
              })
            }
            name="memo"
            rows={2}
          />
        </div>

        <div className="order-item-status-change-info">
          {changeInfo.map((v) => (
            <Fragment key={v}>
              {v} <br />
            </Fragment>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default OrderItemStatusChangeModal;
